import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import dashboardReducer from './dashboardSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Thunk args can carry File/FormData uploads and progress callbacks.
      serializableCheck: { ignoredActionPaths: ['meta.arg'] },
    }),
});
